import {tickets} from "@/store/resources"

export default {
    namespaced: true,
    state: {
        activeTickets: {
            data: [],
            dirty: false
        },
        closedTickets: {
            data: [],
            dirty: false
        },
        currentTicket: {
            data: null,
            dirty: false
        }
    },
    actions: {
        createTicket({}, data) {
            return tickets.tickets.save(data);
        },
        async fetchUserActiveTicketsList({commit}) {
            commit('setUserActiveTicketsDirty');
            const res = await tickets.tickets.get({is_open: 1});
            if (res.body.success) {
                commit('setUserActiveTickets', res.body.data.rows)
            }
        },
        async fetchUserClosedTicketsList({commit}) {
            commit('setUserClosedTicketsDirty');
            const res = await tickets.tickets.get({is_closed: 1});
            if (res.body.success) {
                commit('setUserClosedTickets', res.body.data.rows)
            }
        },
        async fetchUserTicket({commit}, id) {
            commit('setCurrentTicketDirty');
            const res = await tickets.tickets.get({id});
            if (res.body.success) {
                commit('setCurrentTicket', res.body.data.ticket)
            }
        },
        setCurrentTicket({commit}, data) {
            commit('setCurrentTicket', data)
        },
        async sendMessage({state, commit}, formData) {
            return tickets.reply.save({id: state.currentTicket.data.id}, formData);
        },
        updateMessages({commit}, data) {
            commit('setCurrentTicket', data);
        },
        async closeTicket({commit}, id) {
            return tickets.close.save({id}, {});
        }
    },
    mutations: {
        setUserActiveTicketsDirty(state) {
            state.activeTickets.dirty = true;
        },
        setUserClosedTicketsDirty(state) {
            state.closedTickets.dirty = true;
        },
        setUserActiveTickets(state, data) {
            state.activeTickets.dirty = false;
            state.activeTickets.data = data;
        },
        setUserClosedTickets(state, data) {
            state.closedTickets.dirty = false;
            state.closedTickets.data = data;
        },
        setCurrentTicketDirty(state) {
            state.currentTicket.dirty = true;
        },
        setCurrentTicket(state, data) {
            state.currentTicket.dirty = false;
            state.currentTicket.data = data;
        },
        clearCurrentTicket(state) {
            state.currentTicket.dirty = false;
            state.currentTicket.data = null;
        },
    }
}